import { combineReducers } from 'redux';
// eslint-disable-next-line no-restricted-imports
import { connectRouter } from 'connected-react-router';
import accountReducer from './Account/reducer';
import { history } from './history';

export const state = combineReducers({
    router: connectRouter(history),
    accountDomain: accountReducer,
});

export type AppState = ReturnType<typeof state>;

export interface Action {
    type: string;
    payload?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
